import React, { useEffect, useState } from "react";
import { Col, Row, Form, Modal } from "react-bootstrap";
import PropTypes from 'prop-types';
import { Button, Slider, SvgIcon, makeStyles } from "@material-ui/core";
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { TextInput, SelectInput } from '../../Helpers/Inputs';
import SwitchButtons from '../../Quoters/Common/SubComponents/SwitchButtons';
import GenderButtons from '../../Quoters/Common/SubComponents/GenderButtons';
import { NumberFormatDollars, InputMaskDate } from '../../Helpers/Formatters';
import SingleIcon from '../../../icons/Single.svg';
import MarriedIcon from '../../../icons/Married.svg';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import { object, date, string, array as yuparray } from 'yup';
import CurrenyFormat from '../../Helpers/Formatters/CurrencyFormat';
import { useHistory } from "react-router-dom";
import { SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem, setBasicInfo, getBasicInfo, SESSION_STORAGE_BASIC_INFO_KEY, SESSION_STORAGE_ANALYSIS_KEY } from '../../../sessionStorage';
import Age from '../../Helpers/Dates/Age';
import NeedsAnalysisFooter from "./NeedsAnalysisFooter";
import AnalysisData from "../../Helpers/Constants/AnalysisData";
import "./NeedsCalculator.scss";

const white = "#ffffff";
const offWhite = "rgba(255, 255, 255, 0.7)";

const useStyles = makeStyles((theme) => ({
    buttonSelected: {
        borderColor: theme.palette.primary.main,
    },
    svgIcon: {
        '& > g': {
            stroke: theme.palette.primary.main,
        }
    },
    spanTip: {
        color: theme.palette.primary.main,
    },
    white: {
        color: white,
        border: `2px solid ${white}`,
        '&:hover': {
            color: offWhite,
            borderColor: offWhite
        },
        '&:focus': {
            boxShadow: `0 0 5px 0px ${offWhite}`,
            outline: 'none'
        }
    }
}));

export default function NeedsAnalysis(props) {

    const url = window.location.href;

    const classes = useStyles();

    const history = useHistory();

    const sessionStorageFormState = getSessionStorageItem(SESSION_STORAGE_ANALYSIS_KEY);

    const initialFormState = sessionStorageFormState || AnalysisData();

    const [formValues, setFormValues] = useState(initialFormState);
    const [faceTotal, setFaceTotal] = useState(0);
    const [attendCollege, setAttendCollege] = useState(false);

    const { register, errors, formState, triggerValidation, setValue, handleSubmit } = useForm({
        validationSchema: NeedsAnalysis.ValidationSchema(Age(formValues.birthdate)),
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });

    useEffect(() => {
        props.setNeedAnalysisFormValues({ ...formValues })
        register({ name: "birthdate" });
        register({ name: "existingLifeInsuranceAmount" });
        register({ name: "totalSavings" });
        register({ name: "maritalStatus" });
        register({ name: "mortgageBalance" });
        register({ name: "spouseAnnualIncome" });
        register({ name: "annualIncome" });
        register({ name: "totalDebt" });
        register({ name: "monthlyMortgagePayment" });
        register({ name: "normalMonthlyExpenses" });
        register({ name: "totalSavings" });
        register({ name: "existingLifeInsurance" });
        register({ name: "totalInvestments" });
        register({ name: "gender" });
        setValue('mortgageBalance', formValues.mortgageBalance);
        setValue('spouseAnnualIncome', formValues.spouseAnnualIncome);
        setValue('totalDebt', formValues.totalDebt);
        setValue('monthlyMortgagePayment', formValues.monthlyMortgagePayment);
        setValue('normalMonthlyExpenses', formValues.normalMonthlyExpenses);
        setValue('totalSavings', formValues.totalSavings);
        setValue('existingLifeInsurance', formValues.existingLifeInsurance);
        setValue('totalInvestments', formValues.totalInvestments);
        setValue('annualIncome', formValues.annualIncome);
        setValue('birthdate', formValues.birthdate);
        setValue('gender', formValues.gender);

    }, [register]);

    let debounce = null;
    useEffect(() => {

        let isSubscribed = true;
        if (debounce) {
            clearTimeout(debounce);
        }
        debounce = setTimeout(() => updateFace(() => isSubscribed), 1000);
        return () => {
            clearTimeout(debounce);
            isSubscribed = false;
        };
    }, [formValues]);

    useEffect(() => {
        if (formValues.children.some(a => (a.childAge !== null && a.childAge !== "") && Number(a.childAge) < 21)) {
            setAttendCollege(true);
        }
        else {
            setAttendCollege(false);
        }
    },[formValues.children])

    const getChildAges = (children) => {
        let ages = [];
        children.map((value, index) => {
            ages.push(value.childAge);
        });
        return ages;
    };

    function updateFace(getIsSubscribed) {
        let age = formValues.birthdate ? Age(formValues.birthdate) : 0;

        if (formValues.birthdate === "" || formValues.annualIncome === "" || formValues.gender === "" || isNaN(age)) {
            setFaceTotal(0);
            return;
        }

        let spouseAge = (formValues.spouseBirthdate && formValues.maritalStatus === 'Married') ? Age(formValues.spouseBirthdate) : 0;
        const requestObj = {
            CurrentAge: formValues.birthdate ? Age(formValues.birthdate) : 0,
            RetirementAge: null,
            DefaultRetirementAge: null,
            NumberOfYearsToPRovideIncome: null,
            MaintenanceIncome: null,
            AnnualIncome: parseFloat(formValues.annualIncome || 0),
            FuneralAndEstateCosts: null,
            MaintenanceIncomePercentage: (formValues.percentOfIncomeFamily) / 100 || null,
            InflationRate: null,
            AfterTaxNetInvestmentYield: null,
            OutstandingMortgageBalance: parseFloat(formValues.mortgageBalance || 0),
            OutstandingDebts: parseFloat(formValues.totalDebt || 0),
            YearlyCost: null,
            TotalCollegeCost: null,
            CollegeInflationRate: null,
            CurrentSavingsAndInvestments: parseFloat(formValues.totalSavings || 0) + parseFloat(formValues.totalInvestments || 0),
            CurrentRetirementSavings: null,
            EducationalChoice: formValues.childWillAttendCollege,
            BirthDate: formValues.birthdate,
            ChildrenAge: getChildAges(formValues.children),
            SpouseAfterTaxIncome: null,
            SpouseAnnualIncome: parseFloat(formValues.spouseAnnualIncome || 0),
            TaxRate: null,
            SpouseAge: spouseAge,
            spouseBirthDate: (spouseAge === 0 || isNaN(spouseAge)) ? null : formValues.spouseBirthdate,
            SpouseRetirementAge: null,
            CurrentLifeInsuranceCoverage: parseFloat(formValues.existingLifeInsurance || 0),
        };
        fetch('/api/CoverageAdvisor/LifeInsuranceNeedsCalculator', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId
            },
            body: JSON.stringify(requestObj),
        }).then(res => res.json())
            .then(data => {
                if (getIsSubscribed()) {
                    if (data) {
                        if (data.FinalNeed === undefined || data.FinalNeed < 0) {
                            setFaceTotal(0);
                        }
                        else {
                            setFaceTotal(Math.floor(parseFloat(data.FinalNeed)));
                        }
                    }
                }
            }).catch((error) => {
                if (getIsSubscribed()) {
                    setFaceTotal(0);
                }
            });
    }

    const handleInputChange = (fieldName, value) => {
        setValue(fieldName, value);
        const formStateToUpdate = { ...formValues };
        formStateToUpdate[fieldName] = value;
        setFormValues({ ...formStateToUpdate });
        triggerValidation(fieldName);
        props.setNeedAnalysisFormValues({...formStateToUpdate});
    };

    const handleChildrenNumberChange = (fieldName, value) => {
        const newChild = formValues.numberOfChildren === "" ? 0 : formValues.numberOfChildren;
        const formStateToUpdate = { ...formValues };

        if (newChild === 0 || newChild < value) {
            for (let i = newChild; i < value; i++) {
                formStateToUpdate.children.push({ childAge: '' });
                register({ name: `children[${i}].childAge` });
            }
        }
        else {
            const len = newChild - 1;
            for (let i = len; i >= value; i--) {
                formStateToUpdate.children.splice(i, 1);
            }
        }

        formStateToUpdate[fieldName] = value;

        setFormValues({ ...formStateToUpdate });
        setValue(fieldName, value);
        props.setNeedAnalysisFormValues({ ...formStateToUpdate });
    };

    const childInfo = formValues.children.map((value, index) =>
        <NeedsAnalysis.ChildInformation
            index={index}
            formStates={value}
            formState={formState}
            errors={errors.children && errors.children[index]}
            handleArrayInputChange={handleArrayInputChange}
            triggerValidation={triggerValidation}
            onChange={(newForm) => {
                handleInputChange(
                    'children',
                    formValues.children.map((form, formIndex) => {
                        return formIndex === index ? newForm : form;
                    })
                );
            }}
            register={register}
            setValue={setValue}
            key={index}
        />);

    const handleArrayInputChange = (fieldName, value, longFieldName, arrayName, index) => {

        setValue(longFieldName, value);

        const formStateToUpdate = { ...formValues };

        const array = formStateToUpdate[arrayName];
        array[index] = { ...array[index], [fieldName]: value };

        setFormValues({ ...formStateToUpdate });
    };

    function handleClick() {
        const basicInfoFromSessionStorage = getBasicInfo();
        basicInfoFromSessionStorage.gender = formValues.gender === 'Female' ? 'F' : formValues.gender === 'Male' ? 'M' : formValues.gender ? formValues.gender : '';
        basicInfoFromSessionStorage.birthdate = formValues.birthdate;
        basicInfoFromSessionStorage.faceAmount = faceTotal;
        setBasicInfo(basicInfoFromSessionStorage);
        props.fields.setCoverageAmount(faceTotal);
        sessionStorage.setItem(SESSION_STORAGE_ANALYSIS_KEY, JSON.stringify({ ...formValues }));
        props.fields.setModalNeedsCalculatorIsOpen(false);
    }

    const quoteInfo = {
        birthdate: formValues.birthdate,
        gender: formValues.gender,
        faceAmount: Math.floor(parseFloat(faceTotal))
    };

    const isNeedAnalysisPage = url.includes("needs-analysis");

    const routeChange = () => {
        if (!isNeedAnalysisPage) {
            handleClick();
        }
        else {
            sessionStorage.setItem(SESSION_STORAGE_BASIC_INFO_KEY, JSON.stringify(quoteInfo));
            history.push(`/landing/term-insurance`);
            window.scroll(0, 0);
        }
    };

    return (
        <React.Fragment>
            {isNeedAnalysisPage ?
                ''
                : <NeedsAnalysis.ModalHeroImageHeader faceTotal={faceTotal} isPrequote={props.isPrequote} onButtonClick={() => handleClick()} isCustomTerm={props.isCustomTerm} />
            }
            <Form className={`${isNeedAnalysisPage ? '' : 'modal-scroll'}`} onSubmit={handleSubmit(routeChange)}>
                {isNeedAnalysisPage ?
                    <div>
                        <div className="modalImageHeader sticky">
                            <div className="advisorToolHeroImage" />
                            <div className="headerModalDiv sticky-fix">
                                <p id="coverageNeed">My Coverage Need</p>
                                <p id="faceTotal">
                                    <CurrenyFormat whole className="quote-amount-dollars-modal card-rate" number={parseFloat(faceTotal || 0)} />
                                </p>
                                <Button
                                    type="submit"
                                    hidden={faceTotal === 0 || faceTotal === null}
                                    variant="outlined"
                                    size="large"
                                    onClick={() => routeChange}
                                    className={`btn-wide-sm ${classes.white}`}
                                >
                                    {(isNeedAnalysisPage || props.isCustomTerm) ? "Quote Amount" : props.isPrequote ? "Continue" : "Compare Rates"}
                                </Button>
                            </div>
                        </div>
                        <div className="modalImageHeader" >
                            <div className="advisorToolHeroImage" />
                        </div>
                    </div>
                    : ''
                }
                <Row className="needs-calculator justify-content-center">
                    <Col lg={isNeedAnalysisPage ? 8 : 12} md={12}>
                        <Form.Group className="mb-0 mt-4">
                            <GenderButtons
                                selectedGender={formValues.gender}
                                onClickMale={() => handleInputChange('gender', 'Male')}
                                onClickFemale={() => handleInputChange('gender', 'Female')}
                                error={errors.gender}
                            />
                        </Form.Group>
                        <Row>
                            <Form.Group>
                                <Col lg={12}>
                                    <TextInput
                                        name="birthdate"
                                        id="birthdate"
                                        label="Date of Birth"
                                        value={formValues.birthdate}
                                        errors={errors && errors.birthdate}
                                        inputRef={register}
                                        onChange={(e) => handleInputChange('birthdate', e.target.value)}
                                        InputProps={{
                                            inputComponent: InputMaskDate,
                                        }}
                                    />
                                </Col>
                            </Form.Group>
                        </Row>

                        <Form.Group>
                            <SwitchButtons
                                selectedValue={formValues.maritalStatus}
                                buttonOne={{
                                    name: 'Married',
                                    onClick: () => handleInputChange('maritalStatus', 'Married'),
                                    selectedValue: 'Married',
                                    icon: <SvgIcon className={classes.svgIcon} color="primary" component={MarriedIcon} />
                                }}
                                buttonTwo={{
                                    name: 'Single',
                                    onClick: () => handleInputChange('maritalStatus', 'Single'),
                                    selectedValue: 'Single',
                                    icon: <SvgIcon className={classes.svgIcon} color="primary" component={SingleIcon} />
                                }}
                                className="marriedSwitchButtons"
                                error={errors.maritalStatus}
                            />
                        </Form.Group>

                        <Row>
                            <Form.Group>
                                <Col lg={12}>
                                    <SelectInput
                                        name="numberOfChildren"
                                        id="numberOfChildren"
                                        value={formValues.numberOfChildren}
                                        onChange={(e) => handleChildrenNumberChange('numberOfChildren', e.target.value)}
                                        label="Number of Children"
                                        selectOptions={[
                                            { value: 0, label: "None" },
                                            { value: 1, label: "1" },
                                            { value: 2, label: "2" },
                                            { value: 3, label: "3" },
                                            { value: 4, label: "4" },
                                            { value: 5, label: "5" },
                                            { value: 6, label: "6" },
                                            { value: 7, label: "7" },
                                            { value: 8, label: "8" },
                                        ]}
                                        errors={errors.numberOfChildren}
                                        inputRef={register}
                                    />
                                </Col>
                            </Form.Group>
                        </Row>
                        {childInfo}

                        {formValues.numberOfChildren > 0 &&
                            <div>
                                {
                                    attendCollege ?
                                        <Row>
                                            <Form.Group>
                                                <Col lg={12}>
                                                    <SelectInput
                                                        name="childWillAttendCollege"
                                                        id="childWillAttendCollege"
                                                        value={formValues.childWillAttendCollege}
                                                        onChange={(e) => handleInputChange('childWillAttendCollege', e.target.value)}
                                                        label="Child will attend college"
                                                        selectOptions={[
                                                            { value: "2", label: "Private" },
                                                            { value: "0", label: "Public in-State" },
                                                            { value: "1", label: "Public Out-of-State" },
                                                            { value: "3", label: "None" }
                                                        ]}
                                                        errors={errors && errors.childWillAttendCollege}
                                                        inputRef={register}
                                                    />
                                                </Col>
                                            </Form.Group>
                                        </Row> : null
                                }
                                <div className="tooltip-box mb-2">
                                    <span className={classes.spanTip}><SvgIcon style={{ fontSize: '1rem', marginTop: '-4px' }} color="primary" component={EmojiObjectsIcon} />Insider Tip:</span> As of the 2020-2021 academic year, the average tuition and fees range from $9,687 for a public, in-state college to $35,087 for a private college.
                                </div>
                            </div>
                        }
                        <Row>
                            <Form.Group>
                                <Col lg={12}>
                                    <TextInput
                                        name="annualIncome"
                                        id="annualIncome"
                                        label={props.isCustomTerm ? "Annual Income" : "Current Income"}
                                        value={formValues.annualIncome}
                                        errors={errors && errors.annualIncome}
                                        inputRef={register}
                                        onChange={(e) => handleInputChange('annualIncome', e.target.value)}
                                        InputProps={{
                                            inputComponent: NumberFormatDollars,
                                        }}
                                    />
                                </Col>
                            </Form.Group>
                        </Row>

                        {
                            formValues.maritalStatus === 'Married' ?
                                <React.Fragment>
                                    <Row>
                                        <Form.Group>
                                            <Col lg={12}>
                                                <TextInput
                                                    name="spouseBirthdate"
                                                    id="spouseBirthdate"
                                                    label="Spouse Date of Birth"
                                                    value={formValues.spouseBirthdate}
                                                    errors={errors && errors.spouseBirthdate}
                                                    inputRef={register}
                                                    onChange={(e) => handleInputChange('spouseBirthdate', e.target.value)}
                                                    InputProps={{
                                                        inputComponent: InputMaskDate,
                                                    }}
                                                />
                                            </Col>
                                        </Form.Group>
                                    </Row>

                                    <Row>
                                        <Form.Group>
                                            <Col lg={12}>
                                                <TextInput
                                                    name="spouseAnnualIncome"
                                                    id="spouseAnnualIncome"
                                                    label="Spouse Current Income"
                                                    value={formValues.spouseAnnualIncome}
                                                    errors={errors && errors.spouseAnnualIncome}
                                                    inputRef={register}
                                                    onChange={(e) => handleInputChange('spouseAnnualIncome', e.target.value)}
                                                    InputProps={{
                                                        inputComponent: NumberFormatDollars,
                                                    }}
                                                />
                                            </Col>
                                        </Form.Group>
                                    </Row>
                                </React.Fragment>
                                : ''
                        }

                        <Row>
                            <Form.Group>
                                <Col lg={12}>
                                    <p className="incomeInputDescription">% of income my family would need</p>
                                    <p className="incomeInputValue">{formValues.percentOfIncomeFamily}%</p>
                                    <Slider
                                        min={60}
                                        max={100}
                                        step={null}
                                        value={formValues.percentOfIncomeFamily}
                                        onChange={(e, v) => handleInputChange('percentOfIncomeFamily', v)}
                                        className="m-2"
                                        marks={percentAmounts()}
                                    />
                                </Col>
                            </Form.Group>
                        </Row>

                        <div className="tooltip-box mb-2">
                            <span className={classes.spanTip}><SvgIcon style={{ fontSize: '1rem', marginTop: '-4px' }} color="primary" component={EmojiObjectsIcon} />Insider Tip:</span>  Typically a family's need is approximately 80% of one's income.
                        </div>

                        <Row>
                            <Form.Group>
                                <Col lg={12}>
                                    <TextInput
                                        name="mortgageBalance"
                                        id="mortgageBalance"
                                        label="Mortgage Balance"
                                        value={formValues.mortgageBalance}
                                        errors={errors && errors.mortgageBalance}
                                        inputRef={register}
                                        onChange={(e) => handleInputChange('mortgageBalance', e.target.value)}
                                        InputProps={{
                                            inputComponent: NumberFormatDollars,
                                        }}
                                    />
                                </Col>
                            </Form.Group>
                        </Row>
                        {!props.isCustomTerm &&
                            <Row>
                                <Form.Group>
                                    <Col lg={12}>
                                        <TextInput
                                            name="monthlyMortgagePayment"
                                            id="monthlyMortgagePayment"
                                            label="Monthly Mortgage Payment"
                                            value={formValues.monthlyMortgagePayment}
                                            errors={errors && errors.monthlyMortgagePayment}
                                            inputRef={register}
                                            onChange={(e) => handleInputChange('monthlyMortgagePayment', e.target.value)}
                                            InputProps={{
                                                inputComponent: NumberFormatDollars,
                                            }}
                                        />
                                    </Col>
                                </Form.Group>
                            </Row>
                        }

                        <Row>
                            <Form.Group>
                                <Col lg={12}>
                                    <TextInput
                                        name="totalDebt"
                                        id="totalDebt"
                                        label="Total Debt"
                                        value={formValues.totalDebt}
                                        errors={errors && errors.totalDebt}
                                        inputRef={register}
                                        onChange={(e) => handleInputChange('totalDebt', e.target.value)}
                                        InputProps={{
                                            inputComponent: NumberFormatDollars,
                                        }}
                                    />
                                </Col>
                            </Form.Group>
                        </Row>

                        <div className="tooltip-box mb-2">
                            <span className={classes.spanTip}><SvgIcon style={{ fontSize: '1rem', marginTop: '-4px' }} color="primary" component={EmojiObjectsIcon} />Insider Tip:</span> Total debt is all the money you owe minus your mortgage. This can include debts such as credit card balances, student loans, car or recreational vehicle loans.
                        </div>

                        {!props.isCustomTerm &&
                            <Row>
                                <Form.Group>
                                    <Col lg={12}>
                                        <TextInput
                                            name="normalMonthlyExpenses"
                                            id="normalMonthlyExpenses"
                                            label="Normal Monthly Expenses"
                                            value={formValues.normalMonthlyExpenses}
                                            errors={errors && errors.normalMonthlyExpenses}
                                            inputRef={register}
                                            onChange={(e) => handleInputChange('normalMonthlyExpenses', e.target.value)}
                                            InputProps={{
                                                inputComponent: NumberFormatDollars,
                                            }}
                                        />
                                    </Col>
                                </Form.Group>
                            </Row>
                        }

                        <Row>
                            <Form.Group>
                                <Col lg={12}>
                                    <TextInput
                                        name="totalSavings"
                                        id="totalSavings"
                                        label="Total Savings"
                                        value={formValues.totalSavings}
                                        errors={errors && errors.totalSavings}
                                        inputRef={register}
                                        onChange={(e) => handleInputChange('totalSavings', e.target.value)}
                                        InputProps={{
                                            inputComponent: NumberFormatDollars,
                                        }}
                                    />
                                </Col>
                            </Form.Group>
                        </Row>

                        <Row>
                            <Form.Group>
                                <Col lg={12}>
                                    <TextInput
                                        name="totalInvestments"
                                        id="totalInvestments"
                                        label={props.isCustomTerm ? "Total Investments (Including Retirement)" : "Total Investments"}
                                        value={formValues.totalInvestments}
                                        errors={errors && errors.totalInvestments}
                                        inputRef={register}
                                        onChange={(e) => handleInputChange('totalInvestments', e.target.value)}
                                        InputProps={{
                                            inputComponent: NumberFormatDollars,
                                        }}
                                    />
                                </Col>
                            </Form.Group>
                        </Row>

                        <Row>
                            <Form.Group>
                                <Col lg={12}>
                                    <TextInput
                                        name="existingLifeInsurance"
                                        id="existingLifeInsurance"
                                        label="Existing Life Insurance"
                                        value={formValues.existingLifeInsurance}
                                        errors={errors && errors.existingLifeInsurance}
                                        inputRef={register}
                                        onChange={(e) => handleInputChange('existingLifeInsurance', e.target.value)}
                                        InputProps={{
                                            inputComponent: NumberFormatDollars,
                                        }}
                                    />
                                </Col>
                            </Form.Group>
                        </Row>
                        <Row className="justify-content-center">
                            <Form.Group>
                                <Col lg={12}>
                                    <Button disabled={faceTotal === 0 || faceTotal === null} type="submit" color="primary" variant="contained" onClick={() => routeChange()} fullWidth>
                                        {(isNeedAnalysisPage || props.isCustomTerm) ? "Quote Amount" : props.isPrequote ? "Continue" : "Compare Rates"}
                                    </Button>
                                </Col>
                            </Form.Group>
                        </Row>
                    </Col>
                </Row>
                {isNeedAnalysisPage ? '' : < NeedsAnalysisFooter isCustomTerm={props.isCustomTerm} />}
            </Form>
        </React.Fragment >
    );
}

NeedsAnalysis.ModalHeroImageHeader = function (props) {

    const { faceTotal } = props;
    const classes = useStyles();

    return (
        <Modal.Header closeButton>
            <div className="modalImageHeader">
                <div className="advisorToolHeroImage" />
                <div className="headerModalDiv">
                    <p id="coverageNeed">My Coverage Need</p>
                    <p id="faceTotal">
                        <CurrenyFormat whole className="quote-amount-dollars-modal card-rate" number={parseFloat(faceTotal || 0)} />
                    </p>
                    <Button
                        hidden={faceTotal === 0 || faceTotal === null}
                        variant="outlined"
                        size="large"
                        onClick={() => props.onButtonClick()}
                        className={`btn-wide-sm ${classes.white}`}
                    >
                        {props.isCustomTerm ? "Quote Amount" : props.isPrequote ? "Continue" : "Compare Rates"}
                    </Button>
                </div>
            </div>
        </Modal.Header >
    );
};

NeedsAnalysis.ChildInformation = function (props) {

    const { index, formStates, errors, register, triggerValidation } = props;

    const onFieldChange = (field, value) => {
        props.onChange({ ...formStates, [field]: value });
    };

    const handleValueChange = (field, value, longFieldName) => {
        props.setValue(longFieldName, value);
        onFieldChange(field, value);
    };

    const handleBlur = () => {
        triggerValidation(["children", "childAge"]);
    };

    return (
        <React.Fragment>
            {props.index === 0 &&
                <p className="childSectionLabel">Child Information</p>
            }

            <Row>
                <Form.Group>
                    <Col lg={12}>
                        <TextInput
                            name={`children[${props.index}].childAge`}
                            id={`children[${props.index}].childAge`}
                            label={`Child${props.index + 1} Age`}
                            value={formStates.childAge}
                            errors={errors && errors.childAge}
                            inputRef={register}
                            type='number'
                            onBlur={handleBlur}
                            onChange={(e) => handleValueChange('childAge', e.target.value, `children[${index}].childAge`)}
                        />
                    </Col>
                </Form.Group>
            </Row>
        </React.Fragment>
    );
};

NeedsAnalysis.propTypes = {
    fields: PropTypes.object,
    isPrequote: PropTypes.bool,
    isCustomTerm: PropTypes.bool,
};

NeedsAnalysis.ModalHeroImageHeader.propTypes = {
    onButtonClick: PropTypes.func,
    faceTotal: PropTypes.number,
    isCustomTerm: PropTypes.bool,
    isPrequote: PropTypes.bool,
};

NeedsAnalysis.ChildInformation.propTypes = {
    formStates: PropTypes.object,
    index: PropTypes.number,
    errors: PropTypes.object,
    register: PropTypes.func,
    onChange: PropTypes.func,
    setAttendCollege: PropTypes.bool,
    setValue: PropTypes.func,
    triggerValidation: PropTypes.func,
};

NeedsAnalysis.ValidationSchema = (currentAge) => {
    return object().shape({
        gender: string().required('Gender is required.'),
        birthdate: date()
            .required('Birthdate is required.')
            .typeError('Invalid date.'),
        children: yuparray(object().shape({
            childAge: string().required("Child Age is required").max(2, 'Invalid Age.').test({
                message: 'Invalid Age.',
                test: (value) => value >= 0
            }).test({ message: `Child's age cannot be greater than parent's age.`, test: (value) => isNaN(currentAge) ? true : currentAge > value })
        })),
        maritalStatus: string().notRequired(),
        annualIncome: string().required('Income is required.'),
        spouseAnnualIncome: string().notRequired(),
        numberOfChildren: string().notRequired(),
        childWillAttendCollege: string().notRequired(),
        mortgageBalance: string().notRequired(),
        monthlyMortgagePayment: string().notRequired(),
        totalDebt: string().notRequired(),
        normalMonthlyExpenses: string().notRequired(),
        totalSavings: string().notRequired(),
        totalInvestments: string().notRequired(),
        existingLifeInsurance: string().notRequired(),
    });
};

const percentAmounts = () => {
    return [
        { value: 60, label: '60%' },
        { value: 65, label: '' },
        { value: 70, label: '' },
        { value: 75, label: '' },
        { value: 80, label: '' },
        { value: 85, label: '' },
        { value: 90, label: '' },
        { value: 95, label: '' },
        { value: 100, label: '100%' },
    ];
};



// WEBPACK FOOTER //
// ./src/components/Tools/NeedsAnalysis/NeedAnalysis.js